export enum GroupTypes {
  Custom = "Custom",
  Department = "Department",
  JobType = "Job Type",
  Location = "Location"
}
